import React from "react";
import { inIframe, getFinalConfig } from "utils";
import { FullPage } from "./FullPage";
import { IFrame } from "./IFrame";
import { Chooser, sortPaymentMethods } from "./Chooser";
import { PAYOUT, PURCHASE } from "utils/constants";

export { ChargeWillAppearOnYourStatementAs, SelectButton } from "./SelectButton";
export { default as PaymentMethodItem } from "./PMList/PaymentMethodItem";
export { default as AddPaymentMethodButtons } from "./AddPaymentMethodButtons";
export { getFinalPaymentMethods } from "./PMFilter";
export { sortPaymentMethods };

// TODO: Could this be moved into components/Container?
const IframeOrFullPageWrapper = (props) => {
  return inIframe() ? (
    <IFrame>
      <Chooser {...props} />
    </IFrame>
  ) : (
    <FullPage>
      <Chooser {...props} />
    </FullPage>
  );
};

const defaultConfig = {
  chooser: {
    include: [],
    exclude: ["banking"],
    addCC: false,
    addPaypal: false,
  },
};
export const PaymentMethods = ({ config = {}, flow, ...rest }) => {
  const { chooser: chooserConfig } = getFinalConfig(flow, defaultConfig, config);
  return (
    <IframeOrFullPageWrapper
      chooserConfig={chooserConfig}
      {...rest}
      showPaymentMethodMenu={false}
    />
  );
};

const defaultPurchaseConfig = {
  chooser: {
    include: [],
    exclude: ["banking"],
    addCC: false,
    addPaypal: false,
  },
};
export const Purchase = ({ config = {}, onReady, onComplete, onError }) => {
  const { chooser: chooserConfig } = getFinalConfig(PURCHASE, defaultPurchaseConfig, config);
  return (
    <IframeOrFullPageWrapper
      chooserConfig={chooserConfig}
      onReady={onReady}
      onComplete={onComplete}
      onError={onError}
      showPaymentMethodMenu={false}
    />
  );
};

const defaultPayoutConfig = {
  chooser: {
    include: ["paypal", "ach", "banking"],
    exclude: [],
    addCC: false,
    addPaypal: false,
  },
};
export const Payout = ({ config = {}, onReady, onComplete }) => {
  const { chooser: chooserConfig } = getFinalConfig(PAYOUT, defaultPayoutConfig, config);
  return (
    <IframeOrFullPageWrapper
      chooserConfig={chooserConfig}
      onReady={onReady}
      onComplete={onComplete}
      showPaymentMethodMenu={true}
    />
  );
};
